import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from "@angular/material/snack-bar";
import { Observable, Subscription } from "rxjs";

export interface UploadProgressSnackbarData {
  fileName: string;
  positionLabel: string;
  progress$: Observable<number>;
  onCancel?: () => void;
}

@Component({
  selector: "app-upload-progress-snackbar",
  templateUrl: "./upload-progress-snackbar.component.html",
  styleUrls: ["./upload-progress-snackbar.component.scss"],
  standalone: false,
})
export class UploadProgressSnackbarComponent implements OnInit, OnDestroy {
  percent = 0;
  private sub: Subscription;

  constructor(
    public snackBarRef: MatSnackBarRef<UploadProgressSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: UploadProgressSnackbarData
  ) {}

  ngOnInit(): void {
    this.sub = this.data.progress$.subscribe({
      next: (p) => (this.percent = p),
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  cancel(): void {
    if (this.data.onCancel) {
      this.data.onCancel();
    }
  }
}
